import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Clear console on app load
if (process.env.NODE_ENV === 'production') {
  console.clear();
}

// Optimized Query Client Configuration - Balanced caching and refetching
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30 * 1000, // Consider data fresh for 30 seconds
      cacheTime: 5 * 60 * 1000, // Keep cached data for 5 minutes
      refetchOnWindowFocus: false, // Don't refetch on window focus by default
      refetchOnMount: false, // Don't always refetch on mount
      refetchOnReconnect: true, // Refetch when reconnecting
      refetchInterval: false, // No auto-refetch by default (components can override)
      refetchIntervalInBackground: false, // Don't refetch in background by default
      keepPreviousData: true, // Keep previous data while fetching
    },
    mutations: {
      // Cache invalidation for mutations
      onSuccess: async (data, variables, context) => {
        // This will be overridden by individual mutations, but provides a fallback
      },
    },
  },
});

// Export queryClient for use in AuthContext
export { queryClient };

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
              <BrowserRouter>
          <App />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
              </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);




